import React, {Fragment} from "react";
import {Modal} from "react-bootstrap";
import Btn100 from "./Btn100";
import BtnText from "./BtnText";
import Checkbox from "./Checkbox";

function FilterModal({ show, className, heading, filterList, btnTextIcon, btnTextText, btn100Text, onClick }) {
  return (
  <Modal show={show} dialogClassName={`filter-modal ${className}`}>
    <Modal.Body>
      <div className="header-band">
        <h5>{heading}</h5>
        <BtnText text={btnTextText} leftIcon={btnTextIcon} color="blue"/>
      </div>
      <div className="filter-list">
        {filterList.map((filterItem, i) =>
          <Fragment key={i}>
            <Checkbox
              checkboxName={filterItem.data}
              text={filterItem.ko}
            />
          </Fragment>
        )}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Btn100 type="button" text={btn100Text} onClick={onClick}/>
    </Modal.Footer>
  </Modal>
  );
}

export default FilterModal;
